// extracted by css-extract-rspack-plugin
export default {"wrapper":"sOe0X","hidden":"LPPYQ","button":"qoemZ","icon":"u1I9I","iconExpanded":"XgjcF"};